import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIcon from "material-ui/svg-icons/editor/drag-handle";

import Image from "./Image";

import "./Image.css";

const sortByOrder = (imageA, imageB) => {
  if (imageA.order !== undefined && imageB.order !== undefined) {
    if (imageA.order !== imageB.order) {
      return imageA.order - imageB.order;
    } else {
      return imageA.id - imageB.id;
    }
  }
  return true;
};

export default class ImageList extends Component {
  state = { images: [] };

  componentDidMount = () => {
    const { images } = this.props;
    if (images) {
      this.setState({ images: images.sort(sortByOrder) });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { images } = this.props;
    if (prevProps.images.length !== images.length) {
      this.setState({ images: images.sort(sortByOrder) });
    } else if (
      prevProps.images.reduce((acc, image, index) => {
        return (
          acc ||
          image.id != images[index].id ||
          image.order != images[index].order ||
          image.title != images[index].title ||
          image.alt != images[index].alt ||
          image.facet != images[index].facet
        );
      }, false)
    ) {
      this.setState({ images: images.sort(sortByOrder) });
    }
  };

  onDragStart = () => {};

  onDragEnd = result => {
    const { reorderCallback } = this.props;
    const { images } = this.state;
    if (result.destination) {
      const srcIndex = result.source.index;
      const destIndex = result.destination.index;
      const imageDragged = images.filter(
        (image, index) => index === srcIndex
      )[0];
      const imagesReordered =
        destIndex < srcIndex
          ? [
              ...images.slice(0, destIndex),
              imageDragged,
              ...images.slice(destIndex, srcIndex),
              ...images.slice(srcIndex + 1)
            ]
          : [
              ...images.slice(0, srcIndex),
              ...images.slice(srcIndex + 1, destIndex + 1),
              imageDragged,
              ...images.slice(destIndex + 1)
            ];
      this.setState({ images: imagesReordered });
      if (reorderCallback && typeof reorderCallback === "function") {
        reorderCallback(
          imagesReordered.map((image, index) => {
            return { id: image.id, order: index };
          })
        );
      }
    }
  };

  renderImages = () => {
    const { subtitle } = this.props;
    const { images } = this.state;
    const { updateCallback, deleteCallback } = this.props;
    return (
      <DragDropContext
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
      >
        <Droppable droppableId={`droppable`}>
          {(provided, snapshot) => (
            <div className="" ref={provided.innerRef}>
              <div className="inner">
                <div className="help">
                  <span>{subtitle}</span>
                </div>
                {images.map((tile, index) => (
                  <Draggable key={tile.id} draggableId={tile.id} index={index}>
                    {(provided, snapshot) => (
                      <div>
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div className="image-wrapper">
                            <DragIcon className="image-drag-icon" />
                            <Image
                              key={tile.id}
                              id={tile.id}
                              img={tile.image}
                              label={tile.title}
                              altText={tile.alt}
                              facet={tile.facet}
                              updateCallback={updateCallback}
                              deleteCallback={deleteCallback}
                            />
                          </div>
                        </div>
                        {provided.placeholder}
                      </div>
                    )}
                  </Draggable>
                ))}
              </div>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { title } = this.props;
    const classes = "image-list list";
    return (
      <div className={classes}>
        <div className="title--container">
          <div className="title">
            <span>{title}</span>
          </div>
        </div>
        {this.renderImages()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/merchant/accomodation/ImageList.js